
import Header from '../Header';
import UseToolsPage from '@/views/tools/useToolsPage';
import UseTools from './useTools';
const Tool = () =>{


    return(
        <>
        <Header />
        {/* <UseTools/> */}
        <UseToolsPage />
        </>
    )
}

export default Tool;